<template>
    <li></li>
</template>

<script setup>
</script>

<style scoped>
li {
    height: var(--item-height);
    padding: 0 10px;
    color: var(--f-high);
    font-family: monospace, sans;
    font-size: 1em;
    line-height: var(--item-height);
    background-color: var(--b-med);
    border-radius: var(--border-radius);
}
</style>
